// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"76f38b99","186":"f33aace2","225":"1a6f1ef3","344":"c88d45e7","372":"91797393","573":"661ff0ec","738":"3f5b507a","841":"ba25954b","856":"c2905084"}[chunkId] + ".chunk.js";
};